import React from 'react';

import { PersonEntityFields } from './PersonEntityFields';

export const PersonEntity: React.FC<{
  id?: string;
  disableForm?: boolean;
}> = (props) => (
  <PersonEntityFields
    id={props.id}
    disableForm={props.disableForm}
    includeContactFields
    informationHeadline="Information"
  />
);
